<template>
  <div class="pa-4">
    <h2>Edit content</h2>
    <v-form ref="pageForm">
      <v-text-field
        label="Navigation title"
        v-model="page.navTitle"
        outlined
      ></v-text-field>
      <v-text-field
        label="Page title"
        v-model="page.title"
        outlined
      ></v-text-field>
      <v-text-field
        label="Page subtitle"
        v-model="page.subtitle"
        outlined
      ></v-text-field>
      <p>
        <small
          >You can use the following shortcodes to insert action buttons to the
          content:<br>[button=for-employers], [button=submit-job],
          [button=contact-form], [block=cookie-declaration]</small
        >
      </p>
      <div class="mb-4">
        <label>Sidebar content</label>
        <ckeditor
          :editor="editor"
          :config="editorConfig"
          v-model="page.content.side"
        ></ckeditor>
      </div>
      <div class="mb-4">
        <label>Main content</label>
        <ckeditor
          :editor="editor"
          :config="editorConfig"
          v-model="page.content.main"
        ></ckeditor>
      </div>
      <div>
        <label>Featured image</label>
        <div
          class="preview-image"
          v-if="page.imageUrl"
          :style="'background-image: url(' + page.imageUrl + ');'"
        ></div>
        <v-file-input
          outlined
          v-model="newImage"
          accept="image/png, image/jpeg"
          @change="changeImage()"
        ></v-file-input>
      </div>
      <v-btn color="primary" v-on:click="savePage()">Save page</v-btn>
    </v-form>
  </div>
</template>
<script>
import CKEditor from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  components: {
    ckeditor: CKEditor.component,
  },
  name: "ContentEditor",
  props: {
    page: {
      navTitle: {
        type: "string",
        default: "",
      },
      createdBy: {
        type: "string",
        default: "",
      },
      dateCreated: {
        type: "string",
        default: "",
      },
      editedBy: {
        type: "string",
        default: "",
      },
      dateEdited: {
        type: "string",
        default: "",
      },
      title: {
        type: "string",
        default: "",
      },
      subtitle: {
        type: "string",
        default: "",
      },
      content: {
        type: "object",
        default: {
          main: "",
          side: ""
        },
      },
      imageUrl: {
        type: "string",
        default: "",
      },
    },
  },
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {},
      newImage: null,
    };
  },
  beforeDestroy() {},
  computed: {},
  methods: {
    savePage() {
      let payload = {
        id: this.page.id,
        title: this.page.title,
        subtitle: this.page.subtitle,
        navTitle: this.page.navTitle,
        imageUrl: this.page.imageUrl,
        content: {
          main: this.page.content.main,
          side: this.page.content.side,
        },
      };

      this.$store
        .dispatch("dispatchPutPage", { id: payload.id, pageData: payload })
        .then((page) => {
          // this.$emit("saved", page);
          this.$store.dispatch("commitSnackbar", { show: true, message: "Content page updated", timeout: 4000, color: "primary" });
        });

    },
    changeImage() {
      if (this.newImage !== null) {
        let file = this.newImage;
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.page.imageUrl = reader.result;
        };
        reader.onerror = function () {
          console.log("Error loading image.");
        };
      }
    },
  },
};
</script>
<style scoped>
.preview-image {
  height: 100px;
  background-size: cover;
  border-radius: 6px;
  margin-bottom: 1em;
  background-position: center center;
}
</style>